import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loader from 'react-loader';
import {FormattedMessage} from 'react-intl';
import TagGroup from './../components/TagGroup';
import {fetchTags} from '../actions';
import IdIndex from "../../ui/components/IdIndex";

class TagsContainer extends React.Component {
  componentDidMount() {
    let {fetchTags, intl} = this.props;
    fetchTags(intl.locale);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  fetchIfNeeded(nextProps) {
    if (!nextProps.tags.items && !nextProps.tags.isFetching) {
      nextProps.fetchTags(nextProps.intl.locale);
    }
  }

  render() {
    let groups = {};
    let language = this.props.intl.locale;
    let {tags: {items, isFetching}} = this.props;
    let loaded = items && !isFetching;
    if (!items) {
      items = [];
    }
    items.map(function (item) {
      if (item.attributes.pref[language]) {
        let char = item.attributes.pref[language].substring(0, 1).toLowerCase();
        if (!groups[char]) {
          groups[char] = [];
        }
        groups[char].push(item);
      }
    });
    let tagGroups = [];
    let index = [];
    Object.keys(groups).sort().forEach(function (key) {
      const id = `char-${key}`;
      tagGroups.push(<TagGroup key={key} language={language} char={key} items={groups[key]} groupId={id}/>);
      index.push({
        id,
        label: key.toUpperCase()
      });
    });
    return (
      <div className="tagscontainer">
        <h1><FormattedMessage id="tags"/></h1>
        <IdIndex index={index}/>
        {loaded ? (tagGroups.length > 0 ? tagGroups : <FormattedMessage id="noXFound" values={{subject: <FormattedMessage id="tags"/>}}/>) :
          <Loader loaded={loaded}/>}
      </div>
    );
  }

}

TagsContainer.propTypes = {
  fetchTags: React.PropTypes.func,
  intl: React.PropTypes.object,
  tags: React.PropTypes.object
};


function mapDispatchToProps(dispatch) {
  return {
    fetchTags: bindActionCreators(fetchTags, dispatch)
  };
}

function mapStateToProps(state) {
  let {tags, intl} = state;

  return {
    tags,
    intl
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/tags/containers/TagsContainer.js
 **/